import { useCallback, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

/**
 * Sentinel for "all prompt groups": omit `?group=` rather than writing -1 into the URL.
 * This is a MonitorPromptGroup id, not a ProjectGroup id.
 */
export const ALL_PROMPT_GROUPS_ID = -1;

const usePromptGroupId = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const promptGroupId = useMemo(() => {
    const param = searchParams.get('group');
    if (!param) {
      return ALL_PROMPT_GROUPS_ID;
    }
    const parsed = Number(param);
    return Number.isNaN(parsed) ? ALL_PROMPT_GROUPS_ID : parsed;
  }, [searchParams]);

  const setPromptGroupId = useCallback(
    (groupId: number) => {
      setSearchParams(
        (prev) => {
          const next = new URLSearchParams(prev);
          if (groupId === ALL_PROMPT_GROUPS_ID) {
            next.delete('group');
          } else {
            next.set('group', String(groupId));
          }
          return next;
        },
        { replace: true }
      );
    },
    [setSearchParams]
  );

  return { promptGroupId, setPromptGroupId };
};

export default usePromptGroupId;
